import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource, paramsToString } from "./BaseResource";
class ApplicationMortgageERegistrationResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.applicationId = undefined;
        this.applicationMortgageERegistrationId = undefined;
        this.documentYear = undefined;
        this.documentNumber = undefined;
        this.documentOffice = undefined;
        this.message = undefined;
        this.status = undefined;
        this.registrationDate = undefined;
        this.registrationTime = undefined;
        this.mortgageValue = undefined;
        this.expirationDate = undefined;
    }
    pk(parent, key) {
        return `${this.applicationId?.toString()}`;
    }
    static url(urlParams) {
        const { applicationId, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return `${url}${paramsToString(searchParams)}`;
    }
}
ApplicationMortgageERegistrationResource.urlRoot = apiResourceUrl("mortgage-eregistration");
export { ApplicationMortgageERegistrationResource };
//# sourceMappingURL=ApplicationMortgageERegistrationResource.js.map